export class Coupon{
    valore!: number;
}